export default "__VITE_ASSET__IQu_$tlG__"